module.exports = __webpack_public_path__ + "static/api-c99e353f761d318322c853c03ebcf21b.gif";